// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { ReactComponent as Facebook } from '../../assets/svg/facebook.svg';
import { SocialMediaButton } from '../../styled-components/shared';

const Icon = styled(Facebook)`
  width: 1.5em;
  height: 1.5em;
`;

type FacebookButtonProps = {
  className?: string;
  url: string;
};

const FacebookButton = ({ url, className }: FacebookButtonProps) => {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;

  return (
    <a className={className} href={shareUrl} target="_blank" rel="noopener noreferrer">
      <SocialMediaButton>
        <Icon />
      </SocialMediaButton>
    </a>
  );
};

export default FacebookButton;
